import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconAllocation = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <ellipse cx="9.31542" cy="9.5" rx="8.33495" ry="8.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9.31542 1L9.31543 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M16.6699 6L9.31555 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconAllocation
